import React from 'react';
import LessonList from '../../components/LessonList';
import PageLayoutComponent from '../../components/PageLayout';
import EmptyView from '../../components/EmptyView';
import { Favorites as FavoritesData, Identifier } from '../../types';

type Props = {
    favorites: FavoritesData,
    onFavoriteRemoveClicked: (lessonId: Identifier) => any,
};

export default ({ favorites, onFavoriteRemoveClicked }: Props) => (
    <>
        <PageLayoutComponent layout={favorites.pageLayout} />
        {favorites.sections.map(({ title, itemIconColor, items }) => (
            <section className="category-favorites" key={title}>
                <h4 className="section-header" style={{ color: favorites.sectionHeaderColor }}>{title}</h4>
                <LessonList
                    className="favorite-list"
                    items={items}
                    iconColor={itemIconColor}
                    onRemoveClicked={(lessonId: Identifier) => onFavoriteRemoveClicked(lessonId)}
                />
            </section>
        ))}
        <EmptyView
            list={favorites.sections}
            title="Du hast noch keine Favoriten"
            detail="Geh doch gleich zu unseren Mentals, dort kannst du einzelne Lektionen zu deinen Favoriten hinzufügen."
        />
    </>
);
